import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const Info = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
      <g id="info" transform="translate(1 0.652)">
        <circle id="Ellipse_345" data-name="Ellipse 345" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" cx="13" cy="13" r="13" transform="translate(0 0.348)"/>
        <line id="Ligne_12" data-name="Ligne 12" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" y1="5" transform="translate(13 13.348)"/>
        <line id="Ligne_13" data-name="Ligne 13" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" transform="translate(13 8.348)"/>
      </g>
    </svg>
  </SvgIcon>
);

export default Info;